import * as React from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { TextbookProducts, TextbookProductType } from "shared/types/curriculumTypes"
import { HomeSchoolBlock } from "shared/types/homeschoolTypes"

interface Params {
  textbookProduct: TextbookProductType
  hasScience21Access: boolean
  homeschoolBlocks: HomeSchoolBlock[]
  homeschoolBlock: HomeSchoolBlock
}

/**
 * Validates access to a specific textbook product and redirects if the user doesn't have access.
 */
export default function useValidateTextbookAccess({ textbookProduct, hasScience21Access, homeschoolBlocks, homeschoolBlock }: Params) {
  const navigate = useNavigate()

  React.useEffect(() => {
    if (!window.location.pathname.includes("/textbook")) return
    
    if (!TextbookProducts.includes(textbookProduct)) {
      toast.error("Invalid textbook product. Please contact STEM Sims.")
      navigate("/dashboard/teacher/overview")
      return
    }

    const isHomeschoolProduct = textbookProduct === "homeschool35" || textbookProduct === "homeschool68"

    if (textbookProduct === "eScience21" && !hasScience21Access) {
      toast.error("You do not have access to eScience21. Please contact STEM Sims.")
      navigate("/dashboard/teacher/overview")
      return
    }

    if (isHomeschoolProduct && !homeschoolBlocks.includes(homeschoolBlock)) {
      toast.error(`You do not have access to ${homeschoolBlock}. Please contact STEM Sims.`)
      navigate("/dashboard/teacher/overview")
    }
  }, [textbookProduct, hasScience21Access, homeschoolBlocks, homeschoolBlock, navigate])
}